import { frontendURL } from '../../../helper/URLHelper';

const TasksKanbanView = () => import('./TasksKanbanView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tasks'),
    name: 'tasks_dashboard',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: TasksKanbanView,
  },
];
